// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AutoCompleteAddressCmpModuleScss from "../../styles/AutoCompleteAddressCmp.module.scss";

var styles = AutoCompleteAddressCmpModuleScss;

function AutoCompleteAddressCmp(Props) {
  var text = Props.text;
  var sub_text = Props.sub_text;
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement("div", {
                  className: styles.text
                }, text), React.createElement("div", {
                  className: styles.subtext
                }, sub_text));
}

var make = AutoCompleteAddressCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
